var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('span',{staticClass:"app-logo-icon"}),_c('span',{staticClass:"app-logo-text"},[_vm._v("长会财校")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }